import { SOCIAL_FIELDS } from '../../../lib/socialLinks'

export const MAX_BUSINESS_ADMINS = 5

export const BUSINESS_SOCIAL_FIELDS = SOCIAL_FIELDS.filter(
  field => field.key !== 'website_link',
)
